module.exports = "<p>\r\n  trending works!\r\n</p>\r\n"